import { Box, SimpleGrid} from "@chakra-ui/react";
import CartableTable from "./components/CartableTable";

const Cartable = () => 
{

    return (                         

        <Box pt={{ base: "5px", md: "5px", xl: "5px" }}>


            <SimpleGrid>
                <CartableTable/>
            </SimpleGrid>
        </Box>
       
    );

};
  
export default Cartable;
